export var toggle = function (props) {
    var handler = props.handler, container = props.container, toggleClass = props.toggleClass, _a = props.lockBodyScroll, lockBodyScroll = _a === void 0 ? false : _a;
    var handlerIcon = document.querySelector(handler);
    var dropdownContainer = document.querySelector(container);
    if (handlerIcon && dropdownContainer) {
        handlerIcon.addEventListener('click', function () {
            handlerIcon.classList.toggle(toggleClass);
            dropdownContainer.classList.toggle(toggleClass);
            //lock body scroll
            if (lockBodyScroll)
                document.body.classList.toggle('overflow-hidden');
        });
    }
};
